<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>伙伴管理</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入伙伴名称/编号/电话"
          v-model="searchValue"
          clearable
          style="width: 270px;"
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10" v-if="osg.has('Partners,add')">
          新增伙伴
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          v-if="osg.has('Partners,export')"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'fpi-regex:phone|string#or': searchValue,
                'fpi-regex:_id|string#or': searchValue,
                'in:state|array-integer#and': state == 'archived' ? -1 : '0,1',
                beanName: 'partner',
                title: '伙伴列表'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields" :options="options">
            <template slot="ownerId">
              <el-table-column
                prop="ownerId"
                label="负责人"
                width="100px"
                :formatter="formatterOwner"
              ></el-table-column>
            </template>
            <template slot="depositRatio">
              <el-table-column
                label="支付比例"
                width="200px"
                prop="exts.depositRatio"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ formatDepositRatio(scope.row.exts.depositRatio) }}
                </template>
              </el-table-column>
            </template>
            <template slot="depositFixed">
              <el-table-column
                label="支付定额"
                width="200px"
                prop="exts.depositFixed"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ formatDepositFixed(scope.row.exts.depositFixed) }}
                </template>
              </el-table-column>
            </template>
            <template slot="supplierId">
              <el-table-column
                label="供应商名称"
                width="100px"
                prop="supplierId"
                show-overflow-tooltip
                :formatter="formatSupplierId"
              ></el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="osg.has('Partners,edit') || osg.has('Partners?type=all,edit')"
                    @click.native="doEdit(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>

                  <el-dropdown-item
                    v-if="osg.has('Partners,edit') || osg.has('Partners?type=all,edit')"
                    @click.native="queryPSMaxRatio(scope.row.orgName, scope.row.orgId)"
                  >
                    查询分账比例
                  </el-dropdown-item>
                  <!-- <el-button slot="reference" @click="visible = !visible">手动激活</el-button> -->

                  <el-dropdown-item
                    v-if="
                      (osg.has('Partners,spread') || osg.has('Partners?type=all,spread')) &&
                        scope.row.partnerType == 1
                    "
                    @click.native="viewQR($event, scope.row._id, 'bd')"
                  >
                    查看获客码
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('Partners,spread') || osg.has('Partners?type=all,spread')"
                    @click.native="viewQR($event, scope.row._id, 'tg')"
                  >
                    查看门店码
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      (osg.has('Partners,able') || osg.has('Partners?type=all,able')) &&
                        scope.row.state == 0
                    "
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      (osg.has('Partners,able') || osg.has('Partners?type=all,able')) &&
                        scope.row.state == 1
                    "
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      (osg.has('Partners,remove') || osg.has('Partners?type=all,remove')) &&
                        state != 'archived'
                    "
                    @click.native="doRemove(scope.row.orgId)"
                  >
                    归档
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      (osg.has('Partners,remove') || osg.has('Partners?type=all,remove')) &&
                        state == 'archived'
                    "
                    @click.native="doEnable(scope.row._id)"
                  >
                    恢复
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="伙伴信息" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        labelWidth="180px"
        @changeForm="osg.changeForm"
        :area="area"
      >
        <template slot="address">
          <el-input v-model="formData.address" @blur="getGeocode(formData.address)"></el-input>
        </template>
        <template slot="gpsPoint.longitude">
          <el-input
            v-model="formData.gpsPoint.longitude"
            disabled
            placeholder="根据地址自动生成"
          ></el-input>
        </template>
        <template slot="gpsPoint.latitude">
          <el-input
            v-model="formData.gpsPoint.latitude"
            disabled
            placeholder="根据地址自动生成"
          ></el-input>
        </template>
        <template slot="ownerId">
          <el-select
            v-model="formData.ownerId"
            filterable
            allow-create
            clearable
            placeholder="键入名称可搜索"
          >
            <el-option
              v-for="item in contactList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="partnerType">
          <el-select v-model="formData.partnerType" clearable>
            <el-option
              v-for="item in options.partnerTypes"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </template>
        <template slot="type">
          <el-select v-model="formData.type" clearable>
            <el-option
              v-for="item in options.partnerType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="supplierId">
          <el-select
            v-model="formData.supplierId"
            :remote-method="getSupplier"
            :clearable="true"
            filterable
            remote
            reserve-keyword
            placeholder="可搜索供应商"
            size="small"
            style="width:100%"
          >
            <el-option
              v-for="(item, i) in options.supplierData"
              :key="i"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </template>
        <template slot="serviceType">
          <el-select v-model="formData.serviceType" @change="serviceTypeChange" multiple clearable>
            <el-option
              v-for="item in options.serviceType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="depositRatio">
          <tempalte
            v-if="formData.exts.depositRatio && Object.keys(formData.exts.depositRatio).length > 0"
          >
            <el-form-item
              v-for="(val, key, index) in formData.exts.depositRatio"
              :key="index"
              :label="osg.codelabel('serviceType', key)"
              :style="
                index == Object.keys(formData.exts.depositRatio).length - 1 ? 'margin-bottom:0' : ''
              "
            >
              <div class="mo-input--number">
                <el-input-number
                  :min="0"
                  :max="100"
                  type="number"
                  :controls="false"
                  v-model="formData.exts.depositRatio[key]"
                ></el-input-number>
                <div class="define-append">%</div>
              </div>
            </el-form-item>
          </tempalte>
          <template v-else>
            请选择服务类型
          </template>
        </template>
        <template slot="depositFixed">
          <tempalte
            v-if="formData.exts.depositFixed && Object.keys(formData.exts.depositFixed).length > 0"
          >
            <el-form-item
              v-for="(val, key, index) in formData.exts.depositFixed"
              :key="index"
              :label="osg.codelabel('serviceType', key)"
              :style="
                index == Object.keys(formData.exts.depositFixed).length - 1 ? 'margin-bottom:0' : ''
              "
            >
              <div class="mo-input--number">
                <el-input-number
                  :min="0"
                  type="number"
                  :controls="false"
                  :precision="0"
                  v-model="formData.exts.depositFixed[key]"
                ></el-input-number>
                <div class="define-append">元</div>
              </div>
            </el-form-item>
          </tempalte>
          <template v-else>
            请选择服务类型
          </template>
        </template>
        <template slot="isDepositRatio">
          <template
            v-if="
              formData.exts.isDepositRatio && Object.keys(formData.exts.isDepositRatio).length > 0
            "
          >
            <el-form-item
              v-for="(val, key, index) in formData.exts.isDepositRatio"
              :key="index"
              :label="osg.codelabel('serviceType', key)"
              :style="
                index == Object.keys(formData.exts.isDepositRatio).length - 1
                  ? 'margin-bottom:0'
                  : ''
              "
            >
              <el-switch
                v-model="formData.exts.isDepositRatio[key]"
                active-text="是"
                inactive-text="否"
                active-value="1"
                inactive-value="0"
              ></el-switch>
            </el-form-item>
          </template>
          <template v-else>
            请选择服务类型
          </template>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="type == 'tg' ? '门店码' : '获客码'"
      :visible.sync="openQRDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <div style="display: flex;align-items: center;">
        分享二维码：
        <div class="qrcode" style="margin: 20px 0 0 10px" ref="qrCodeUrl"></div>
      </div>
      <div style="margin-top:26px;">
        <span>
          分享长链接：
        </span>
        <el-link :href="href" target="_blank">{{ `${href}` }}</el-link>
      </div>
      <div slot="footer" style="display: flex;justify-content: space-between;">
        <span></span>
        <el-button type="primary" @click="openQRDetail = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
// import areajs from '../../resources/js/area.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'partner',
  data() {
    return {
      visible: false,
      type: '',
      tenantId: '',
      name: 'partner',
      refresh: true,
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        supplierId: [],
        gpsPoint: {},
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_partnerType: { codeId: 'partnerType' },
        codecfg_partnerTypes: { codeId: 'partnerTypes' },
        codecfg_industry: { codeId: 'INDUSTRY' },
        supplierData: [] //供应商信息
      },
      contactList: [],
      isEdit: false,
      baseUrl: '', //二维码基础路径
      openQRDetail: false, //二维码弹窗
      href: '', //二维码路径
      // 上传
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      //地址
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      state: '' //已归档 archived
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    this.doInit();
    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = acount.tenantId;
    this.queryLocationHost();
    this.osg.getFields('partner', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    // 供应商
    formatSupplierId(row, column, cellValue) {
      return this.osg.codelabelInArray('supplierData', cellValue);
    },
    // 支付比例列表反显
    formatDepositRatio(cellValue) {
      let str = '';
      for (var item in cellValue) {
        str += this.osg.codelabel('serviceType', item) + '：' + cellValue[item] + '%' + '、';
      }
      return str;
    },
    formatDepositFixed(cellValue) {
      let str = '';
      for (var item in cellValue) {
        str += this.osg.codelabel('serviceType', item) + '：' + cellValue[item] + '元' + '、';
      }
      return str;
    },
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatState(row, column, cellValue) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatterIndustry(row, column, cellValue) {
      return this.osg.codelabel('industry', cellValue);
    },
    formatterType(row, column, cellValue) {
      return this.osg.codelabel('partnerType', cellValue);
    },
    formatPartnerTypes(row, column, cellValue) {
      return this.osg.codelabel('partnerTypes', cellValue);
    },
    formatterOwner(row, column, cellValue) {
      let label = this.contactList
        .map(item => {
          if (item.value == cellValue) {
            return item.label;
          }
        })
        .join('');
      if (label) {
        return label;
      } else {
        return cellValue;
      }
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        supplierId: [],
        gpsPoint: {},
        exts: {}
      };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
      this.type = this.osg.param('type');
      this.state = this.osg.param('state');
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:_id|string#or': this.searchValue,
        'in:state|array-integer#and': this.state == 'archived' ? -1 : '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      if (this.type == 'all') {
        params['ne:tenantId|string#and'] = '1340835581184723420';
      }
      //添加过滤器参数
      $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax(
        this.type == 'all' ? 'basic/partner/queryAll.do' : 'basic/partner/query.do',
        params,
        res => {
          this.fpi = res;
          this.$nextTick(() => {
            this.$refs.table && this.$refs.table.doLayout();
            this.$forceUpdate();
          });
          this.getContact();
          this.getSupplier();
        }
      );
    },
    getContact() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 50,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.contactList = res.data;
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    //根据网址 提示域名下拉框
    querySearch(queryString, cb) {
      let url = this.formData.website;
      let reg = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
      if (reg.test(url)) {
        if (url.indexOf('www.') != -1) {
          url = url.substr(url.indexOf('.') + 1);
        } else if (url.indexOf('http://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
        } else if (url.indexOf('https://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
          if (url.indexOf('https://www.') != -1) {
            url = url.substr(url.indexOf('.') + 1);
          }
        }
        // 调用 callback 返回建议列表的数据
        cb([{ label: url, value: url }]);
      } else {
        cb([{}]);
      }
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.isEdit = false;
    },
    doEdit(row) {
      this.isEdit = true;
      row = this.$util.deepCopy(row);
      this.getContact();
      // TODO:新建伙伴选择组织的逻辑
      // row.description = [row.description];
      if (row.exts) {
        for (let key in row.exts) {
          if (this.$util.isJson(row.exts[key])) {
            row.exts[key] = JSON.parse(row.exts[key]);
          }
        }
      }
      // //将多选的下拉存成JSON字符串
      // for (let item of this.extFields) {
      //   if (item.type == 'select' && Array.isArray(params.exts[item.name])) {
      //     params.exts[item.name] = JSON.stringify(params.exts[item.name]);
      //   }
      // }
      this.$util.renderExtField(this.extFields, row);
      row.gpsPoint = row.gpsPoint || {};
      // 自动赋值支付定额
      if (row.exts && row.exts.depositRatio && !row.exts.depositFixed) {
        let depositFixed = {};
        for (let key in row.exts.depositRatio) {
          depositFixed[key] = 0;
        }
        row.exts.depositFixed = depositFixed;
      }
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        let params = this.$util.deepCopy(this.formData);
        params.description = params.description && String(params.description);
        // extField.type == 'select'
        //将多选的下拉存成JSON字符串
        // for (let item of this.extFields) {
        //   if (item.type == 'select' && Array.isArray(params.exts[item.name])) {
        //     params.exts[item.name] = JSON.stringify(params.exts[item.name]);
        //   }
        // }
        this.$util.saveFormatExtField(this.extFields, params);

        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
              if (params.area.length > 3) {
                params.subdistrict = params.area[3] || '';
              }
            }
          }
        }

        this.osg.ajax('basic/partner/upsert.do', { partnerStr: JSON.stringify(params) }, res => {
          this.osg.ajax(
            'basic/partner/updateOrgName.do',
            {
              partnerName: res.data.name,
              orgId: res.data.orgId
            },
            () => {}
          );
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/partner/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/partner/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    queryServiceResources(orgId) {
      return new Promise(resolve => {
        this.osg.ajax(
          'biz/serviceResource/query.do',
          {
            'all:serviceCrewId|string#and': orgId,
            sortField: 'createTime',
            sortOrder: 'desc'
          },
          res => {
            if (res.data) {
              resolve(!res.data.length ? false : res.data[0]._id);
            }
          }
        );
      });
    },
    doRemove(orgId) {
      this.osg.confirm('是否确认归档？', () => {
        this.osg.ajax(`basic/partner/remove/${orgId}.do`, null, () => {
          this.osg.toast('归档成功');
          this.getData();
        });
      });
    },
    //基础（前缀）路径
    queryLocationHost() {
      this.osg.ajax(
        'config/queryLocationHost.do',
        {},
        res => {
          this.baseUrl = res.data;
        },
        { noload: true }
      );
    },
    //查看二维码
    viewQR(e, partnerId, type) {
      this.type = type;
      if (type == 'tg') {
        this.href = `${this.baseUrl}tg/?type=tg&partnerId=${partnerId}`;
      } else if (type == 'bd') {
        this.href = `${this.baseUrl}bd/?type=bd&partnerId=${partnerId}`;
      }
      this.openQRDetail = true;
      this.$nextTick(() => {
        this.bindQRCode();
      });
    },
    //生成二维码
    bindQRCode() {
      new QRCode(this.$refs.qrCodeUrl, {
        text: `${this.href}`,
        width: 200,
        height: 200,
        colorDark: '#333333', //二维码颜色
        colorLight: '#ffffff', //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    },
    //删除空数组并且扁平化
    removeEmpty(arr) {
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          if (item.orgList ? item.orgList.length === 0 : false) {
            delete item.orgList;
          } else {
            this.removeEmpty(item.orgList);
          }
        });
        return arr;
      }
    },
    formatterCodelabel(cellValue, valueOption) {
      if (valueOption) {
        return this.osg.codelabel(valueOption, cellValue);
      } else {
        return cellValue;
      }
    },
    renderCompute(formula) {
      return eval(formula);
    },
    //获取地理编码
    async getGeocode(address) {
      if (!address) {
        this.formData.gpsPoint = {};
        this.formData.exts.citycode = '';
        this.formData.exts.address = '';
        return;
      }
      let str = '';
      if (this.$refs.form.$refs.area && this.$refs.form.$refs.area[0].getCheckedNodes()[0]) {
        let arr = this.$refs.form.$refs.area[0].getCheckedNodes()[0].pathLabels;
        if (arr && arr.constructor == Array) {
          for (let item of arr) {
            str += item;
          }
        }
      }
      this.formData.exts.address = str + address;
      this.osg.geocode(str + address, res => {
        if (!res) {
          this.formData.gpsPoint = {};
          this.formData.exts.citycode = '';
          return;
        }
        this.formData.gpsPoint = {
          longitude: res.location.split(',')[0],
          latitude: res.location.split(',')[1]
        };
        this.formData.exts.citycode = res.citycode;
        this.$forceUpdate();
      });
    },
    serviceTypeChange(value) {
      this.options.serviceType.map(item => {
        let serviceType = item.value;
        if (value.indexOf(serviceType) != -1) {
          // 合同类型
          if (
            !this.formData.exts['contractType' + serviceType] ||
            this.formData.exts['contractType' + serviceType].length == 0
          ) {
            let contractType =
              this.options['contractType' + serviceType] &&
              this.options['contractType' + serviceType].map(item => item.value);
            this.$set(this.formData.exts, 'contractType' + serviceType, contractType || []);
          }
          // 质保单类型
          if (
            !this.formData.exts['warrantyType' + serviceType] ||
            this.formData.exts['warrantyType' + serviceType].length == 0
          ) {
            let warrantyType =
              this.options['warrantyType' + serviceType] &&
              this.options['warrantyType' + serviceType].map(item => item.value);
            this.$set(this.formData.exts, 'warrantyType' + serviceType, warrantyType || []);
          }
          // 支付比例
          if (!this.formData.exts.depositRatio) {
            this.$set(this.formData.exts, 'depositRatio', { [serviceType]: 0 });
          } else if (!this.formData.exts.depositRatio[serviceType]) {
            this.$set(this.formData.exts.depositRatio, serviceType, 0);
          }
          // 支付定额
          if (!this.formData.exts.depositFixed) {
            this.$set(this.formData.exts, 'depositFixed', { [serviceType]: 0 });
          } else if (!this.formData.exts.depositFixed[serviceType]) {
            this.$set(this.formData.exts.depositFixed, serviceType, 0);
          }
          // 是否开启支付比例
          if (!this.formData.exts.isDepositRatio) {
            this.$set(this.formData.exts, 'isDepositRatio', { [serviceType]: '1' });
          } else if (!this.formData.exts.isDepositRatio[serviceType]) {
            this.$set(this.formData.exts.isDepositRatio, serviceType, '1');
          }
        } else {
          this.$set(this.formData.exts, 'contractType' + serviceType, []);
          this.$set(this.formData.exts, 'warrantyType' + serviceType, []);
          if (this.formData.exts.depositRatio) delete this.formData.exts.depositRatio[serviceType];
          if (this.formData.exts.depositFixed) delete this.formData.exts.depositFixed[serviceType];
          if (this.formData.exts.isDepositRatio)
            delete this.formData.exts.isDepositRatio[serviceType];
        }
      });
      console.log('formData', this.formData);
    },
    getSupplier(searchVal) {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:name|string#or': searchVal,
        // 'regex:phone|string#or': searchVal,
        'regex:_id|string#or': searchVal,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/supplier/query.do', params, res => {
        this.supplierData = res.data;
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.supplierData = res.data;
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
        });
        this.$forceUpdate();
      });
    },
    // 查询服务商分账比例
    queryPSMaxRatio(orgName, orgId) {
      this.osg.ajax('i/pay/queryPSMaxRatio.do?orgId=' + orgId, {}, res => {
        this.osg.alert(
          (res.data.ratioWechat ? `微信支付：${res.data.ratioWechat}<br/>` : '') +
            (res.data.ratioAli ? `支付宝支付： ${res.data.ratioAli}` : ''),
          null,
          `${orgName}的分账比例为`,
          true
        );
      });
    }
  }
  // watch: {
  //   $route() {
  //     window.$this = this;
  //     this.doInit();
  //     this.osg.getFpi();
  //     this.getData();
  //   }
  // }
};
</script>
<style scoped lang="scss">
/**/
.content-table >>> .el-cascader.el-cascader--small {
  pointer-events: none;
}
.content-table >>> .el-cascader .el-input .el-input__inner {
  border: 0;
}
.content-table >>> .el-input__suffix {
  right: 5px;
  transition: all 0.3s;
  display: none;
}
.content-table >>> .el-input__inner {
  background: transparent;
}
.cascaderPartners >>> input {
  width: 240px;
}

/* 自定义数字输入框append  */
.mo-input--number {
  border: 1px solid #dcdfe6;
  width: 100%;
  display: flex;
  border-radius: 4px;
  .el-input-number--mini {
    flex: 1;
  }
  ::v-deep .el-input__inner {
    border: none !important;
  }
}

.define-append {
  width: 50px;
  display: inline-block;
  background: #f5f7fa;
  height: 32px;
  line-height: 32px;
  color: #909399;
  font-size: 12px;
  text-align: center;
}
</style>
